import { render, staticRenderFns } from "./PublicationTable.vue?vue&type=template&id=5b03e38e&scoped=true&"
import script from "./PublicationTable.vue?vue&type=script&lang=js&"
export * from "./PublicationTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicationTable.vue?vue&type=style&index=0&id=5b03e38e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03e38e",
  null
  
)

export default component.exports